import {
  type WorkArrangementData,
  getWorkArrangementDisplayText,
} from '@seek/unified-display-work-arrangement';
import { useTranslations } from '@vocab/react';

import { useConfig } from 'src/app/shared/hooks/useConfig';
import translations from 'src/app/v1/views/components/Workplace/.vocab';
import { WorkArrangement } from 'src/graphql/generated';

export const useFormattedWorkArrangements = () => {
  const { t } = useTranslations(translations);
  const { getLocale } = useConfig();
  const workArrangementLabel: Record<string, string> = {
    [WorkArrangement.ONSITE]: t('on-site-label'),
    [WorkArrangement.HYBRID]: t('hybrid-label'),
    [WorkArrangement.REMOTE]: t('remote-label'),
  };

  const getFormattedWorkArrangements = (
    workArrangements: WorkArrangement[] | null,
  ) => {
    const formattedWorkArrangements: WorkArrangementData[] =
      workArrangements?.map((workArrangement: string, index: number) => ({
        id: index.toString(),
        label: { text: workArrangementLabel[workArrangement] || '' },
      })) || [];

    return getWorkArrangementDisplayText(
      formattedWorkArrangements,
      getLocale(),
    );
  };

  return {
    getFormattedWorkArrangements,
  };
};
